import axios from '../../functions/axios';
import { useEffect, useState, useMemo, useCallback } from 'react';
import leftArrow from '../../assets/images/selection_left.png';
import rightArrow from '../../assets/images/selection_right.png';
import editButton from '../../assets/images/editButton.png';
import style from './CarriageList.module.css';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuthContext } from '../../hooks/useAuthContext';
import { parseDate } from '../../functions/functions';

const Carriage = ({ carriage, navigate, apiData, setApiData }) => {
  const { user } = useAuthContext();
  const onDocumentationChange = async (event, carriage) => {
    const checkboxState = !!event.target.checked;
    const confirmBox = window.confirm(checkboxState ? 'Czy chcesz dodać dokumenty?' : 'Czy chcesz usunąć dokumenty?');
    if (!confirmBox) return;

    const response = await axios
      .patch(`/carriage`, {
        _id: carriage._id,
        documentation: checkboxState,
      })
      .catch(console.log);

    if (!response?.data?._id) return;

    const newApiData = apiData.reduce((acc, value) => {
      if (value._id === response.data._id) {
        return [
          ...acc,
          {
            ...value,
            documentation: response.data.documentation,
          },
        ];
      }
      return [...acc, value];
    }, []);

    setApiData(newApiData);
  };
  const onInvoicePaymentChange = async (event, carriage) => {
    const checkboxState = !!event.target.checked;
    const confirmBox = window.confirm(checkboxState ? 'Płatność zaksięgowana?' : 'Usunąć płatność?');
    if (!confirmBox) return;

    const response = await axios
      .patch(`/carriage`, {
        _id: carriage._id,
        invoicePay: checkboxState,
      })
      .catch(console.log);

    if (!response?.data?._id) return;

    const newApiData = apiData.reduce((acc, value) => {
      if (value._id === response.data._id) {
        return [
          ...acc,
          {
            ...value,
            invoiceStatus: response.data.invoiceStatus,
            invoicePay: response.data.invoicePay,
          },
        ];
      }
      return [...acc, value];
    }, []);

    setApiData(newApiData);
  };

  const invoiceStatus = (() => {
    if (carriage.invoicePay) return '10px solid green';
    switch (carriage.invoiceStatus) {
      case 'PAID':
        return '10px solid green';
      case 'CLOSE_DEADLINE':
        return '10px solid yellow';
      case 'OVERDUE':
        return '10px solid red';
      default:
        return '10px solid #636363';
    }
  })();

  return (
    <div className={style.carriageData} key={carriage._id} style={{ borderRight: invoiceStatus, borderRadius: '10px' }}>
      <div className={style.driver}>{carriage.driver?.name.split(' ').reduce((acc, element) => [acc, <br />, element]) || '-'}</div>
      <div className={style.day}>
        {new Date(carriage.day).toLocaleString('pl', { weekday: 'long' })}
        <br />
        {new Date(carriage.day).toLocaleDateString('pl')}
      </div>
      <div className={style.timocom}>
        {carriage.client?.companyName || carriage.client?.name || carriage.oneTimeClient || '-'} <br />
        {carriage.timocomID || carriage.client?.timocomID || '-'}
      </div>
      <div className={style.route}>
        <ul className={style.routeList}>
          <li className={style.routeStart}>{carriage.routeStart || '-'}</li>
          <li className={style.to}>{carriage.routeEnd || '-'}</li>
        </ul>
      </div>
      <div className={style.cost} style={{ textAlign: 'right' }}>
        {carriage.cost?.toLocaleString('pl-PL', { style: 'currency', currency: carriage.currency || 'EUR' }) || '-'}
        <br />
        {carriage.counterStart >= 0 && carriage.counterEnd
          ? `(${(Math.round((carriage.cost / (carriage.counterEnd - carriage.counterStart)) * 100) / 100).toLocaleString('pl-PL', {
              style: 'currency',
              currency: carriage.currency || 'EUR',
            })} / km)`
          : '-'}
      </div>

      <div className={style.carriageWeight} style={{ textAlign: 'center' }}>
        {carriage.carriageWeight || '-'}
      </div>
      <div className={style.invoice} style={{ textAlign: 'center' }}>
        {carriage.invoice || '-'}
      </div>
      <div className={style.invoiceDate} style={{ textAlign: 'center' }}>
        {carriage.invoiceDate ? new Date(carriage.invoiceDate).toLocaleDateString('pl') : '- '}
        <br />
        {
          <input
            id='invoicePay'
            type='checkbox'
            name='invoicePay'
            checked={carriage.invoicePay}
            onChange={(event) => onInvoicePaymentChange(event, carriage)}
            disabled={!(user?.permissions?.manageInvoice || user?.permissions?.administrator)}
          />
        }
      </div>
      <div className={style.doc} style={{ textAlign: 'center' }}>
        {
          <input
            id='documentation'
            type='checkbox'
            name='documentation'
            checked={carriage.documentation}
            onChange={(event) => onDocumentationChange(event, carriage)}
            disabled={!(user?.permissions?.manageInvoice || user?.permissions?.administrator)}
          />
        }
      </div>
      {/* <div className={style.status}>{(carriage.counterStart >= 0 && carriage.counterEnd) ? 'Ukończono' : 'W trakcie realizacji'}</div> */}
      <span style={{ textAlign: 'center' }}>
        <img className={style.editButton} src={editButton} onClick={() => navigate('/editCarriage', { state: carriage })} alt='edycja'/>
      </span>
    </div>
  );
};

const Navigation = ({ setWeekDate, changeWeek, currentDate, navigate, searchQueryPlate }) => {
  const weekDate = ['monday', 'sunday'].map((day) => new Date(parseDate(currentDate)[day]).toLocaleDateString('pl')).join(' - ');

  return (
    <div className={style.navigation}>
      <button className={`${style.addReport} btn btn-default`} onClick={navigate.bind(null, '/printCarriage', { state: { searchQuery: searchQueryPlate } })}>
        Drukuj
      </button>
      {/* <RaportPDF customStyle={`${style.addReport} btn btn-default`} apiData={apiData} /> */}
      <p>{weekDate}</p>
      <img src={leftArrow} onClick={changeWeek.bind(null, -1)} alt='Arrow left' />
      <span className={style.weekNumber} onClick={() => setWeekDate(new Date())}>
        {parseDate(currentDate).week}
      </span>
      <img src={rightArrow} onClick={changeWeek.bind(null, 1)} alt='Arrow right' />
      <button className={`${style.carriageNote} btn`} onClick={navigate.bind(null, '/carriageNotes', { state: { date: currentDate } })}>
        Ładunki
      </button>
      <button className={`${style.addCarriage} btn btn-default`} onClick={navigate.bind(null, '/addCarriage')}>
        Dodaj Trasę
      </button>
    </div>
  );
};

export default function WeekView() {
  const location = useLocation();
  const [isLoading, setLoading] = useState(true);
  const [apiData, setApiData] = useState([]);
  const initDate = parseDate(Date.parse(location.state?.date || sessionStorage.getItem('selectedWeek') || new Date())).monday;
  const [currentDate, setCurrentDate] = useState(initDate);
  const navigate = useNavigate();
  const { user } = useAuthContext();
  const [searchQueryPlate, setSearchQueryPlate] = useState('');
  const [searchQueryDriver, setSearchQueryDriver] = useState('');
  const [searchQueryInvoice, setSearchQueryInvoice] = useState('');
  const [searchQueryRoute, setSearchQueryRoute] = useState('');
  const [searchQueryClient, setSearchQueryClient] = useState('');

  const setWeekDate = useCallback((date) => {
    const selectedDate = parseDate(date).monday;
    sessionStorage.setItem('selectedWeek', selectedDate);
    setCurrentDate(selectedDate);
  }, []);

  const changeWeek = useCallback(
    (offsetWeeks) => {
      const date = parseDate(currentDate).addDays(7 * offsetWeeks).monday;
      setWeekDate(date);
    },
    [currentDate, setWeekDate],
  );

  const filteredData = useMemo(() => {
    return apiData
      .filter((carriage) => {
        if (searchQueryPlate === '') return true;
        return carriage.car?.plate?.replace(/\s+/g, '').toUpperCase().includes(searchQueryPlate);
      })
      .filter((carriage) => {
        if (searchQueryDriver === '') return true;
        return carriage.driver?.name?.toLowerCase().includes(searchQueryDriver.toLowerCase());
      })
      .filter((carriage) => {
        if (searchQueryInvoice === '') return true;
        return carriage.invoice?.toLowerCase().includes(searchQueryInvoice.toLowerCase());
      })
      .filter((carriage) => {
        if (searchQueryRoute === '') return true;
        return (
          carriage.routeStart?.toLowerCase().includes(searchQueryRoute.toLowerCase()) ||
          carriage.routeEnd?.toLowerCase().includes(searchQueryRoute.toLowerCase())
        );
      })
      .filter((carriage) => {
        if (searchQueryClient === '') return true;
        return (carriage.client?.companyName || carriage.client?.name || carriage.oneTimeClient || '')?.toLowerCase().includes(searchQueryClient.toLowerCase());
      });
  }, [apiData, searchQueryPlate, searchQueryDriver, searchQueryInvoice, searchQueryRoute, searchQueryClient]);

  const cars = useMemo(() => {
    return [...new Set(filteredData.map((data) => data.car?.plate))].sort((...args) => {
      const [a, b] = args.map((plate) => plate.toUpperCase());
      return a.localeCompare(b, 'pl-PL', { sensitivity: 'base' });
    });
  }, [filteredData]);

  useEffect(() => {
    const source = axios.CancelToken.source();

    (async () => {
      if (!user) return null;
      setLoading(true);
      setApiData([]);
      try {
        const { monday, sunday } = parseDate(currentDate);
        const response = await axios.get(`/carriage`, {
          params: {
            startDate: monday,
            endDate: sunday,
            populate: ['car', 'driver', 'client', 'creator'],
          },
          cancelToken: source.token,
        });
        if (Array.isArray(response.data)) {
          setApiData(response.data);
        }
      } catch (error) {
        if (axios.isCancel(error)) {
          console.log('axios request canceled');
          return;
        }
        console.log(error);
      } finally {
        setLoading(false);
      }
    })();

    return () => {
      source.cancel();
    };
  }, [user, currentDate]);

  if (isLoading) {
    return null;
  }

  if (!apiData.length) {
    return (
      <>
        {<Navigation setWeekDate={setWeekDate} changeWeek={changeWeek} currentDate={currentDate} navigate={navigate} searchQueryPlate={searchQueryPlate} />}
        {!apiData.length ? <div className={style.missingData}>Brak danych do wyświetlenia...</div> : null}
      </>
    );
  }

  return (
    <>
      <div className={style.container}>
        {<Navigation setWeekDate={setWeekDate} changeWeek={changeWeek} currentDate={currentDate} navigate={navigate} searchQueryPlate={searchQueryPlate} />}
        <div style={{ display: 'flex', justifyContent: 'space-around' }}>
          <div className={style.filter}>
            <label htmlFor='searchCar'>Wyszukaj pojazd:</label>
            <input
              id='searchCar'
              type='search'
              placeholder='Nr rejestracyjny'
              value={searchQueryPlate}
              onChange={(e) => setSearchQueryPlate(e.target.value.trim().replace(/\s+/g, '').toUpperCase())}
            />
          </div>
          <div className={style.filter}>
            <label>Wyszukaj kierowcę:</label>
            <input
              type='search'
              className='form-control'
              placeholder='Nazwisko'
              value={searchQueryDriver}
              onChange={(e) => setSearchQueryDriver(e.target.value)}
            ></input>
          </div>
          <div className={style.filter}>
            <label>Wyszukaj klienta:</label>
            <input
              type='search'
              className='form-control'
              placeholder='Klient'
              value={searchQueryClient}
              onChange={(e) => setSearchQueryClient(e.target.value)}
            ></input>
          </div>
          <div className={style.filter}>
            <label>Wyszukaj trasę:</label>
            <input
              type='search'
              className='form-control'
              placeholder='Trasa'
              value={searchQueryRoute}
              onChange={(e) => setSearchQueryRoute(e.target.value)}
            ></input>
          </div>
          <div className={style.filter}>
            <label>Wyszukaj fakturę:</label>
            <input
              type='search'
              className='form-control'
              placeholder='Faktura'
              value={searchQueryInvoice}
              onChange={(e) => setSearchQueryInvoice(e.target.value)}
            ></input>
          </div>
        </div>
        <div className={style.mainHeader}>
          <span>Pojazd</span>
          <span>Kierowca</span>
          <span>Data</span>
          <span>Klient</span>
          {/*}<span>TIMOCOM ID</span>*/}
          <span>Z/Do</span>
          <span>Stawka</span>
          <span>Waga transportu</span>
          <span>Faktura</span>
          <span>Termin płatności</span>
          <span>Dokumenty</span>
          {/* <span>Status wykonania</span> */}
          <span>Edycja</span>
        </div>
        {cars.map((plate) => (
          <div className={style.carWeek} key={plate}>
            <div className={style.plate}>{plate.toUpperCase()}</div>
            <div className={style.data}>
              {filteredData
                .filter((carriage) => carriage.car.plate === plate)
                .sort((...args) => {
                  const [a, b] = args.map(({ day }) => Date.parse(day));
                  return a - b;
                })
                .map((carriage) => <Carriage key={carriage._id} carriage={carriage} navigate={navigate} apiData={apiData} setApiData={setApiData} />)
                .reduce((acc, element) => [acc, <hr className={style.dimmed} />, element])
              }
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
